
window.__wxOriginalUrl = window.location.href


if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {}; // 建议保留 error
}

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {getRequest,getRequest20,getRequestCommon,getRequestNotGateWay} from "@/api/getRequest"

import * as filters from './filters' // 全局筛选器

// 导入vant组件
import './utils/vant.js'

// 全局注册筛选器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

//将包挂载到vue的原型对象上
Vue.prototype.$getRequestData = getRequest
Vue.prototype.$getRequestData20 = getRequest20
Vue.prototype.$getRequestCommon = getRequestCommon
Vue.prototype.$getRequestNotGateWay = getRequestNotGateWay


Vue.filter('maskStr', (str) => {
  if (!str || str.length <= 10) return str;
  return str.substring(0, 3) + '******' + str.substring(9);
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
